// Single source of truth para datos de contacto y dirección de Eclipse Cubiertas.
// Importar desde aquí en lugar de hardcodear en componentes.
export const BUSINESS_INFO = {
    name: "Eclipse Cubiertas",
    legalName: "Eclipse Cubiertas SA de CV",
    whatsapp: { display: "+52 81 1628 9267", number: "528116289267" },
    phone: { display: "+52 81 8989 9822", number: "+528189899822", numberRaw: "528189899822" },
    phone: { display: "+52 81 8989 9822", number: "+528189899822" },
    email: "info@eclipsecubiertas.com",
    address: {
        street: "Calle San Pedro No. 157",
        detail: "Bodega No. 8, Extora Park Flex Space",
        neighborhood: "Col. 4",
        postalCode: "66367",
        city: "Santa Catarina",
        state: "Nuevo León",
        country: "México",
        countryCode: "MX",
        region: "NLE",
        lat: 25.687958,
        lng: -100.469647,
        mapsUrl: "https://maps.app.goo.gl/7fqaFjJ1Mn2QLMz77",
    },
    hours: "Lunes a Viernes 9:00 - 18:00",
    socials: {
        youtube: "https://www.youtube.com/@eclipsegrupo",
    },
};

export const MAPS_URL = BUSINESS_INFO.address.mapsUrl;
